import Axios from "axios";
import { url } from "../../global";

const fetchDNReport = (filter) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'DNREPORT',
            payload: Axios.get(`${url}/dn-report`, {
                params: {
                    page: filter.page,
                    perpage: filter.perpage,
                    keyword: filter.keyword,
                    ordering: filter.ordering,
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

export { fetchDNReport };